export default __webpack_public_path__ + "static/media/IMG-20210926-WA0007.f1686282.jpg";